import React from 'react';
import { Col, Row } from 'react-bootstrap-5';
import EmptyState from 'shared/empty_state';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { NonBasicCardStyling } from './util';
import { type PreviewEyeProps } from './preview_eye';

type SyndicationPartner = {
  banner: string,
  id: number,
  order: number,
  partner_name: string
}
export type Props = {
  preview: boolean,
  previewEye: PreviewEyeProps,
  syndicationPartners: SyndicationPartner[]
}

export default function SyndicationCard({ preview, previewEye, syndicationPartners }: Props) {
  function contentForCard() {
    return (
      <>
        <div className="ds-text-muted">Published on the Buildout Syndication Network, including these channels:</div>
        <Row>
          {syndicationPartners.map((syndicationPartner, index) => (
            <Col className={`${index > 1 ? 'mt-3' : ''}`} key={syndicationPartner.id} md={6}>
              <img
                alt=""
                className="img-responsive"
                src={syndicationPartner.banner}
                style={{ filter: 'grayscale(1)' }}
              />
            </Col>
          ))}
        </Row>
      </>
    );
  }

  return (
    <div className={NonBasicCardStyling}>
      <div className="d-flex justify-content-between align-items-center">
        <h4 className="m-0 fw-normal">Syndication</h4>
        { !preview && previewEye }
      </div>
      {syndicationPartners.length > 0 ? contentForCard() : (
        <EmptyState
          bodyText="Waiting For Data..."
          header="No Syndication data to display"
          icon={faExclamationCircle}
          iconSize="3x"
          style={{ minHeight: '250px' }}
        />
      )}
    </div>
  );
}
